// ReelHunt — catch log for hunters and anglers: photos, GPS and automatic weather, maps with water depths,
// private encrypted groups. Everything is stored on the phone (IndexedDB).
//
// Entry point. Importing a module sets up its part of the screen (event handlers, render hooks); this file loads
// them all and starts the app. Where things are:
//   state.ts      catches in memory, render() hooks        db.ts        IndexedDB
//   i18n.ts       language, t(), number/date formats       dom.ts       el(), $(), toast()
//   list.ts       Catches tab                              editor.ts    catch form          detail.ts  one catch
//   map/          Map tab: layers, pins, wind, offline areas, GPX
//   groups/       Groups tab: encryption, relay sync, chat, sharing, club stand board, photo feed
//   tips.ts       profile and weather tips                 insights.ts  learning from your catches
//   push.ts       notifications                            safety.ts    daily copies, backup reminder
//   backup.ts     backup file                              season.ts    season recap        settings.ts  language, theme
//   usage.ts      anonymous daily usage report             combo.ts     type-or-pick field
//   account.ts    optional email sign-in, Account panel    cloud.ts     cloud backup
//   billing.ts    ReelHunt Plus and club plan (RevenueCat)  paywall.ts   paywall, Plus panel   groups/clubplan.ts  club unlock
//   trip/         trip mode: suggested spots (spots.ts), route, summary, past trips (trip.ts); sheltered spots for the wind (shelter.ts)
import { dbAll } from "./db.ts";
import { toast } from "./dom.ts";
import { t } from "./i18n.ts";
import { upgrade } from "./species.ts";
import { render, setCatches } from "./state.ts";
import { setView, view } from "./views.ts";
import { refreshWeather } from "./weather.ts";
import { applyStatic, applyTheme } from "./settings.ts";
import "./list.ts";
import "./editor.ts";
import "./detail.ts";
import "./backup.ts";
import "./map/bigmap.ts";
import "./map/places.ts";
import "./map/wind.ts";
import "./map/offline.ts";
import "./map/gpx.ts";
import "./groups/chat.ts";
import "./groups/club.ts";
import "./groups/feed.ts";
import "./season.ts";
import "./insights.ts";
import "./feedback.ts";
import "./trip/shelter-ui.ts";
import { loadPlaces } from "./map/places.ts";
import { groupsStart } from "./groups/ui.ts";
import { tipsStart } from "./tips.ts";
import { pushStart } from "./push.ts";
import { safetyStart } from "./safety.ts";
import { usageStart } from "./usage.ts";
import { account, accountStart } from "./account.ts";
import { billingStart } from "./billing.ts";
import "./paywall.ts";
import { cloudStart } from "./cloud.ts";
import { tripStart } from "./trip/trip.ts";

applyStatic();
applyTheme();

(async () => {
  try { setCatches((await dbAll("catches")).map(upgrade)); }
  catch (e) { console.error(e); toast(t("storageBlocked")); }
  await loadPlaces();
  render();
  setView(view);
  void groupsStart();
  tipsStart();
  void pushStart();
  void safetyStart();
  void refreshWeather();
  usageStart();
  accountStart();
  void billingStart(account?.id ?? null);
  cloudStart();
  void tripStart();
})();

// Offline support on the hosted site (not on localhost, so edits show up straight away while developing).
if ("serviceWorker" in navigator && location.protocol === "https:") navigator.serviceWorker.register("sw.js").catch(() => {});
